import { createContext, useContext } from 'react';

import type { CmsApiReactionContext } from 'modules/cms/api/reactions/types/CmsApiReactionContext';

export const CmsReactionsContext = createContext<CmsApiReactionContext>({
  reactions: { LIKE: 0, LOVE: 0, INSPIRED: 0 },
  latestReactions: [],
  ownReaction: null,
  totalReactions: 0,
});

export const useCmsReactionsContext = () => useContext(CmsReactionsContext);
